<template>
    <div class="c2b-container">
        <div class="c2b-router-name-container">
            <p class="c2b-router-name">Faturamento</p>
        </div>

        <div class="c2b-content">
            <div class="modal" tabindex="-1" role="dialog" id="c2b-billing-list-filter-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Filtro</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-6 form-group">
                                    <label>Data inicial</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="billingFilterForm.date.start" />
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Data final</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="billingFilterForm.date.end" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Cliente</label>
                                    <multiselect
                                        v-model="billingFilterForm.subscriber"
                                        :options="subscriberList"
                                        :multiple="false"
                                        :show-labels="false"
                                        :searchable="true"
                                        :internal-search="false"
                                        :loading="loadingSubscribers"
                                        :show-no-results="true"
                                        @search-change="getSubscribers"
                                        label="name"
                                        track-by="id"
                                        placeholder="">
                                        <span slot="noOptions">Digite um nome para iniciar a pesquisa</span>
                                        <span slot="noResult">Nenhum resultado encontrado</span>
                                    </multiselect>
                                </div>

                                <div class="col-12 form-group">
                                    <label>Tipo</label>
                                    <multiselect
                                        v-model="billingFilterForm.typeList"
                                        :options="billingTypeList"
                                        :multiple="true"
                                        :show-labels="false"
                                        label="name"
                                        track-by="id"
                                        placeholder="" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Status do faturamento</label>
                                    <multiselect
                                        v-model="billingFilterForm.status"
                                        :options="billingStatusList"
                                        :multiple="false"
                                        :show-labels="false"
                                        :allow-empty="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="getBillingListWithFilter(billingFilterForm)"
                                :disabled="loadingFilter">
                                    Filtrar
                                    <Loading v-show="loadingFilter" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="clearFilter()">Restaurar</button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeFilterModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-billings-creation-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Criação de faturamento</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Período de referência</label>

                                    <multiselect
                                        class="w-50 float-left"
                                        v-model="billingCreation.date.month"
                                        :options="availableMonthList"
                                        :multiple="false"
                                        :show-labels="false"
                                        :allow-empty="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="" />

                                    <input type="number" 
                                        class="form-control w-50 float-left" 
                                        style="height: 40px;"
                                        v-model="billingCreation.date.year">
                                </div>

                                <div class="col-12 form-group">
                                    <label>Produto</label>
                                    <multiselect
                                        v-model="billingCreation.product"
                                        :options="productList"
                                        :multiple="false"
                                        :show-labels="false"
                                        :allow-empty="false"
                                        label="name"
                                        track-by="id"
                                        placeholder="" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Cliente (opcional)</label>
                                    <multiselect
                                        v-model="billingCreation.subscriber"
                                        :options="subscriberList"
                                        :multiple="false"
                                        :show-labels="false"
                                        :searchable="true"
                                        :internal-search="false"
                                        :loading="loadingSubscribers"
                                        :show-no-results="true"                                        
                                        @search-change="getSubscribers"
                                        label="name"
                                        track-by="id"
                                        placeholder="">
                                        <span slot="noOptions">Digite um nome para iniciar a pesquisa</span>
                                        <span slot="noResult">Nenhum resultado encontrado</span>
                                    </multiselect>
                                    <small class="text-muted">Apenas informar o cliente quando o faturamento for específico.</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="createBillings(billingCreation)"
                                :disabled="!billingCreation.isValid() || creatingBillings">
                                    Criar faturamento
                                    <Loading v-show="creatingBillings" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeBillingCreationModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-billing-documents-creation-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Gerar cobrança</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-6 form-group">
                                    <label>Data inicial</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="billingDocumentCreation.billingDueStartDate" />
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Data final</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="billingDocumentCreation.billingDueEndDate" />
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Vencimento do boleto</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="billingDocumentCreation.billetDueDate" />
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Data de emissão da NFS-e</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="billingDocumentCreation.invoiceIssueDate" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Cliente (opcional)</label>
                                    <multiselect
                                        v-model="billingDocumentCreation.subscriber"
                                        :options="subscriberList"
                                        :multiple="false"
                                        :show-labels="false"
                                        :searchable="true"
                                        :internal-search="false"
                                        :loading="loadingSubscribers"
                                        :show-no-results="true"
                                        @search-change="getSubscribers"
                                        label="name"
                                        track-by="id"
                                        placeholder="">
                                        <span slot="noOptions">Digite um nome para iniciar a pesquisa</span>
                                        <span slot="noResult">Nenhum resultado encontrado</span>
                                    </multiselect>
                                    <small class="text-muted">Apenas informar o cliente quando o faturamento for específico.</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="createBillingDocuments(billingDocumentCreation)"
                                :disabled="!billingDocumentCreation.isValid() || creatingBillingDocuments">
                                    Gerar
                                    <Loading v-show="creatingBillingDocuments" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeBillingDocumentsCreationModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-approve-billet-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Aprovar boleto</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-8 form-group">
                                    <label>Cliente</label>
                                    <p>{{billing.subscriberProduct.subscriber.name}}</p>
                                    <small class="text-muted">{{billing.subscriberProduct.subscriber.document}}</small>
                                </div>                                

                                <div class="col-12 col-md-4 form-group">
                                    <label>Criado em</label>
                                    <p>{{billing.createdAt | dateFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Descrição</label>
                                    <p>{{billing.description | infoOrPlaceholder}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-4 form-group">
                                    <label>Tipo</label>
                                    <p>{{billing.type.name | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Total</label>
                                    <p>{{billing.total | currency}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Vencimento</label>
                                    <p>{{billing.dueDate | dateFromStringFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Data de pagamento</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="approvedPayment.paymentDate" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="approveBilletPayment(billing, approvedPayment)"
                                :disabled="!approvedPayment.isValid() || approvingBilletPayment">
                                    Aprovar pagamento
                                    <Loading v-show="approvingBilletPayment" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeApproveBilletModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-specific-billing-modal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="float-left">
                                <h5 class="modal-title">Detalhes da cobrança</h5>
                                <p class="text-muted mb-0">{{billing.createdAt | dateFilter}}</p>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-8 form-group">
                                    <label>Cliente</label>
                                    <p>{{billing.subscriberProduct.subscriber.realName}}</p>
                                    <small class="text-muted">{{billing.subscriberProduct.subscriber.name}}</small>
                                    <br>
                                    <small class="text-muted">{{billing.subscriberProduct.subscriber.document}}</small>
                                </div>

                                <div class="col-12 col-md-2 form-group">
                                    <label>Tipo</label>
                                    <p>{{billing.type.name}}</p>
                                </div>

                                <div class="col-12 col-md-2 form-group">
                                    <label>Total</label>
                                    <p>{{billing.total | currency}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-8 form-group">
                                    <label>Descrição</label>
                                    <p>{{billing.description | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Email</label>
                                    <p class="mb-0"
                                       v-for="(email, index) in billing.getEmailList()" :key="index">{{email}}</p>
                                </div>
                            </div>
                            
                            <div class="row">                                
                                <div class="col-12 col-md-2 form-group">
                                    <label>Referência</label>
                                    <p>{{billing.referenceDate | dateFromStringFilter}}</p>
                                </div>

                                <div class="col-12 col-md-2 form-group">
                                    <label>Vencimento</label>
                                    <p>{{billing.dueDate | dateFromStringFilter}}</p>
                                </div>

                                <div class="col-12 col-md-2 form-group">
                                    <label>Pago em</label>
                                    <p>{{billing.paymentDate | dateFilter | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12 col-md-2 form-group">
                                    <label>Status</label>
                                    <span v-show="billing.hasBeenCanceled()">
                                        <span class="badge badge-danger">Cancelado</span>
                                    </span>
                                    <span v-show="billing.hasBilletBeenPaid() && !billing.hasBeenCanceled()">
                                        <span class="badge badge-success">Pago</span>
                                    </span>
                                    <span v-show="!billing.hasBilletBeenPaid() && !billing.isOverdue() && !billing.hasBeenCanceled()">
                                        <span class="badge badge-info">Em aberto</span>
                                    </span>
                                    <span v-show="billing.isOverdue()">
                                        <span class="badge badge-danger">Vencido</span>
                                    </span>
                                </div>

                                <div class="col-12 col-md-2 form-group">
                                    <label>Boleto</label>
                                    <a v-show="billing.hasBillets() && !billing.getBillet().hasBeenCanceled()"
                                        :href="billing.getBilletUrlView()"
                                        target="_blank">
                                        <span class="badge badge-info">Sim</span>
                                    </a>
                                    <a v-show="billing.hasBillets() && billing.getBillet().hasBeenCanceled()"
                                        :href="billing.getBilletUrlView()"
                                        target="_blank">
                                        <span class="badge badge-danger">Cancelado</span>
                                    </a>
                                    <span v-show="!billing.hasBillets()">
                                        <span class="badge badge-dark">Não</span>
                                    </span>
                                </div>

                                <div class="col-12 col-md-2 form-group">
                                    <label>NFS-e</label>
                                    <a v-show="billing.hasInvoices() && !billing.getInvoice().hasBeenCanceled()"
                                        :href="billing.getInvoiceUrl()"
                                        target="_blank">
                                        <span class="badge badge-info">Sim</span>
                                    </a>
                                    <a v-show="billing.hasBillets() && billing.getInvoice().hasBeenCanceled()"
                                        :href="billing.getInvoiceUrl()"
                                        target="_blank">
                                        <span class="badge badge-danger">Cancelado</span>
                                    </a>
                                    <span v-show="!billing.hasInvoices()">
                                        <span class="badge badge-dark">Não</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-outline-primary" 
                                v-show="!billing.hasBilletBeenPaid()"
                                :disabled="approvingBilletPayment"
                                @click="approveBilletPayment(billing, approvedPayment)">
                                
                                Aprovar pagamento

                                <Loading v-show="approvingBilletPayment" />
                            </button>

                            <a :href="billing.getBilletUrlView()" 
                                v-show="billing.hasBillets()"
                                class="btn btn-outline-secondary"
                                target="_blank">Visualizar Boleto <fa icon="external-link-alt" class="ml-2" /></a>

                            <a :href="billing.getInvoiceUrl()"                                                 
                                v-show="billing.hasInvoices()"
                                class="btn btn-outline-secondary"
                                target="_blank">Visualizar NFS-e <fa icon="external-link-alt" class="ml-2" /></a>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeSpecificBillingModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-update-billing-information-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="float-left">
                                <h5 class="modal-title">Atualizar informações da cobrança</h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-8 form-group">
                                    <label>Cliente</label>
                                    <p>{{billing.subscriberProduct.subscriber.name}}</p>
                                    <small class="text-muted">{{billing.subscriberProduct.subscriber.document}}</small>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Criado em</label>
                                    <p>{{billing.createdAt | dateFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Descrição</label>
                                    <p>{{billing.description | infoOrPlaceholder}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-4 form-group">
                                    <label>Tipo</label>
                                    <p>{{billing.type.name}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Total</label>
                                    <p>{{billing.total | currency}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Vencimento</label>
                                    <p>{{billing.dueDate | dateFromStringFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Nova data de vencimento</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="billingUpdateInformation.newDueDate" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Email</label>
                                    <textarea type="text" 
                                        rows="2"
                                        class="form-control"
                                        v-model="billingUpdateInformation.email" ></textarea>
                                    <small class="text-muted">Para informar mais de um email basta separar por vírgula.</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                :disabled="!billingUpdateInformation.isValid() || updatingBillingInformation"
                                @click="updateBillingInformation(billing, billingUpdateInformation)">
                                
                                Atualizar informações

                                <Loading v-show="updatingBillingInformation" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeUpdateBillingInformationModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-resend-billing-email-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="float-left">
                                <h5 class="modal-title">Reenviar boleto</h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-8 form-group">
                                    <label>Cliente</label>
                                    <p>{{billing.subscriberProduct.subscriber.name}}</p>
                                    <small class="text-muted">{{billing.subscriberProduct.subscriber.document}}</small>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Criado em</label>
                                    <p>{{billing.createdAt | dateFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Descrição</label>
                                    <p>{{billing.description | infoOrPlaceholder}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-4 form-group">
                                    <label>Tipo</label>
                                    <p>{{billing.type.name}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Total</label>
                                    <p>{{billing.total | currency}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Vencimento</label>
                                    <p>{{billing.dueDate | dateFromStringFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <label>Email</label>
                                    <textarea type="text" 
                                        rows="2"
                                        class="form-control"
                                        v-model="billingEmail.email"></textarea>
                                    <small class="text-muted">Para informar mais de um email basta separar por vírgula.</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                :disabled="!billingEmail.isValid() || submittingResendEmail"
                                @click="resendBillingEmail(billing, billingEmail)">
                                
                                Reenviar

                                <Loading v-show="submittingResendEmail" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeResendBillingEmailModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-billing-cancelation-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="float-left">
                                <h5 class="modal-title">Cancelamento de faturamento</h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-8 form-group">
                                    <label>Cliente</label>
                                    <p>{{billing.subscriberProduct.subscriber.name}}</p>
                                    <small class="text-muted">{{billing.subscriberProduct.subscriber.document}}</small>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Criado em</label>
                                    <p>{{billing.createdAt | dateFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Descrição</label>
                                    <p>{{billing.description | infoOrPlaceholder}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-4 form-group">
                                    <label>Tipo</label>
                                    <p>{{billing.type.name}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Total</label>
                                    <p>{{billing.total | currency}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Vencimento</label>
                                    <p>{{billing.dueDate | dateFromStringFilter}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                :disabled="cancelingBilling"
                                @click="cancelOrDeleteBilling(billing)">
                                <span v-show="!billing.hasBeenCanceled()">Cancelar</span>
                                <span v-show="billing.hasBeenCanceled()">Excluir</span>

                                faturamento

                                <Loading v-show="cancelingBilling" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeBillingCancelationModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-billet-cancelation-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="float-left">
                                <h5 class="modal-title">Cancelamento de boleto</h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-8 form-group">
                                    <label>Cliente</label>
                                    <p>{{billing.subscriberProduct.subscriber.name}}</p>
                                    <small class="text-muted">{{billing.subscriberProduct.subscriber.document}}</small>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Criado em</label>
                                    <p>{{billing.createdAt | dateFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Descrição</label>
                                    <p>{{billing.description | infoOrPlaceholder}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-4 form-group">
                                    <label>Tipo</label>
                                    <p>{{billing.type.name}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Total</label>
                                    <p>{{billing.total | currency}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Vencimento</label>
                                    <p>{{billing.dueDate | dateFromStringFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <label>Motivo</label>
                                    <textarea type="text" 
                                        rows="3"
                                        class="form-control"
                                        v-model="billetCancelation.reason"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                :disabled="!billetCancelation.isValid() || cancelingBillet"
                                @click="cancelBillet(billing, billetCancelation)">
                                
                                Cancelar boleto

                                <Loading v-show="cancelingBillet" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeBilletCancelationModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-invoice-cancelation-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="float-left">
                                <h5 class="modal-title">Cancelamento de NFS-e</h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-8 form-group">
                                    <label>Cliente</label>
                                    <p>{{billing.subscriberProduct.subscriber.name}}</p>
                                    <small class="text-muted">{{billing.subscriberProduct.subscriber.document}}</small>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Criado em</label>
                                    <p>{{billing.createdAt | dateFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Descrição</label>
                                    <p>{{billing.description | infoOrPlaceholder}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-4 form-group">
                                    <label>Tipo</label>
                                    <p>{{billing.type.name}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Total</label>
                                    <p>{{billing.total | currency}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Vencimento</label>
                                    <p>{{billing.dueDate | dateFromStringFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <label>Motivo</label>
                                    <multiselect
                                        v-model="invoiceCancelation.cancelationCodeWrapper"
                                        :options="invoiceCancelationCodeOptions"
                                        :multiple="false"
                                        :show-labels="false"
                                        :allow-empty="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                :disabled="!invoiceCancelation.isValid() || cancelingInvoice"
                                @click="cancelInvoice(billing, invoiceCancelation)">
                                
                                Cancelar NFS-e

                                <Loading v-show="cancelingInvoice" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeInvoiceCancelationModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-billet-history-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="float-left">
                                <h5 class="modal-title">Histórico do boleto</h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-8 form-group">
                                    <label>Cliente</label>
                                    <p>{{billing.subscriberProduct.subscriber.name}}</p>
                                    <small class="text-muted">{{billing.subscriberProduct.subscriber.document}}</small>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Criado em</label>
                                    <p>{{billing.createdAt | dateFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Descrição</label>
                                    <p>{{billing.description | infoOrPlaceholder}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-4 form-group">
                                    <label>Tipo</label>
                                    <p>{{billing.type.name}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Total</label>
                                    <p>{{billing.total | currency}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Vencimento</label>
                                    <p>{{billing.dueDate | dateFromStringFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <label>Histórico</label>
                                </div>
                                <div class="billet-history-container">
                                    <div class="col-12 billet-history" v-for="(info, index) in billetHistoryList" :key="index">
                                        <small class="text-muted">{{info.created_at}}</small>
                                        <p class="mb-0">{{info.message}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeBilletHistoryModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="c2b-billet-log-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="float-left">
                                <h5 class="modal-title">Log do boleto</h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-8 form-group">
                                    <label>Cliente</label>
                                    <p>{{billing.subscriberProduct.subscriber.name}}</p>
                                    <small class="text-muted">{{billing.subscriberProduct.subscriber.document}}</small>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Criado em</label>
                                    <p>{{billing.createdAt | dateFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Descrição</label>
                                    <p>{{billing.description | infoOrPlaceholder}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-4 form-group">
                                    <label>Tipo</label>
                                    <p>{{billing.type.name}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Total</label>
                                    <p>{{billing.total | currency}}</p>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Vencimento</label>
                                    <p>{{billing.dueDate | dateFromStringFilter}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <label>Log</label>
                                </div>
                                <div class="billet-history-container">
                                    <div class="col-12 billet-history" v-for="(log, index) in billetLogList" :key="index">
                                        <small class="text-muted">{{log.date | dateTimeFilter}}</small>
                                        <p class="mb-0">{{log.getDescription()}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeBilletLogModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <Loading v-if="loading" />

            <div v-show="!loading">
                <div class="mb-3">
                    <button class="btn btn-primary" 
                        @click="openFilterModal()" 
                        :disabled="openingFilterModal">
                        Filtro

                        <Loading v-show="openingFilterModal" />
                    </button>

                    <button class="btn btn-outline-secondary ml-3" 
                        :disabled="openingBillingCreationModal"
                        @click="openBillingCreationModal()">
                        Criar faturamento

                        <Loading v-show="openingBillingCreationModal" />
                    </button>

                    <button class="btn btn-outline-secondary ml-3" 
                        @click="openBillingDocumentsCreationModal()">
                        Gerar cobrança
                    </button>

                    <json-to-csv
                        class="btn btn-outline-secondary ml-3"
                        :data="billingListCsv"
                        name="faturamento.csv">
                        Exportar para CSV
                    </json-to-csv>
                </div>

                <FilterInformationCmp 
                    v-if="!loading"
                    :filter-submitted="billingFilterSubmitted"
                    :filter-properties="billingFilterProperties" />

                <NothingFound v-if="nothingToShow" />

                <div class="table-responsive" v-show="!nothingToShow">
                    <table class="table table-hover table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Cliente</th>
                                <th>Tipo</th>
                                <th>Vencimento</th>
                                <th>Status</th>
                                <th>Boleto</th>
                                <th>NFS-e</th>
                                <th class="text-right">Total</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(billing, index) of billingList" :key="index">
                                <td>
                                    <p class="mb-0">{{billing.subscriberProduct.subscriber.realName}}</p>
                                    <small class="text-muted mb-0">{{billing.subscriberProduct.subscriber.name}}</small>
                                    <br>
                                    <small class="text-muted mb-0">{{billing.subscriberProduct.subscriber.alias}}</small>
                                </td>
                                <td>{{billing.type.name}}</td>
                                <td>{{billing.dueDate | dateFromStringFilter}}</td>
                                <td>
                                    <span v-show="billing.hasBeenCanceled()">
                                        <span class="badge badge-danger">Cancelado</span>
                                    </span>
                                    <span v-show="billing.hasBilletBeenPaid() && !billing.hasBeenCanceled()">
                                        <span class="badge badge-success">Pago</span>
                                    </span>
                                    <span v-show="!billing.hasBilletBeenPaid() && !billing.isOverdue() && !billing.hasBeenCanceled()">
                                        <span class="badge badge-info">Em aberto</span>
                                    </span>
                                    <span v-show="billing.isOverdue()">
                                        <span class="badge badge-danger">Vencido</span>
                                    </span>
                                </td>
                                <td>
                                    <a v-show="billing.hasBillets() && !billing.getBillet().hasBeenCanceled()"
                                        :href="billing.getBilletUrlView()"
                                        target="_blank">
                                        <span class="badge badge-info">Sim</span>
                                    </a>
                                    <a v-show="billing.hasBillets() && billing.getBillet().hasBeenCanceled()"
                                        :href="billing.getBilletUrlView()"
                                        target="_blank">
                                        <span class="badge badge-danger">Cancelado</span>
                                    </a>
                                    <span v-show="!billing.hasBillets()">
                                        <span class="badge badge-dark">Não</span>
                                    </span>
                                </td>
                                <td>
                                    <a v-show="billing.hasInvoices() && !billing.getInvoice().hasBeenCanceled()"
                                        :href="billing.getInvoiceUrl()"
                                        target="_blank">
                                        <span class="badge badge-info">Sim</span>
                                    </a>
                                    <a v-show="billing.hasBillets() && billing.getInvoice().hasBeenCanceled()"
                                        :href="billing.getInvoiceUrl()"
                                        target="_blank">
                                        <span class="badge badge-danger">Cancelado</span>
                                    </a>
                                    <span v-show="!billing.hasInvoices()">
                                        <span class="badge badge-dark">Não</span>
                                    </span>
                                </td>
                                <td class="text-right">{{billing.total | currency}}</td>
                                <td class="text-center c2b-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted" 
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" v-show="!billing.loadingListAction"/>
                                        <fa icon="sync-alt" spin v-show="billing.loadingListAction"/>
                                    </button>

                                    <div class="dropdown-menu">                                        
                                        <span class="dropdown-item" 
                                            @click="openSpecificBillingModal(billing)">Detalhes</span>

                                        <span class="dropdown-item"
                                            v-show="!billing.hasBilletBeenPaid()"
                                            @click="openUpdateBillingInformationModal(billing)">Atualizar informações da cobrança</span>

                                        <div>
                                            <p class="dropdown-divider" v-show="billing.hasBillets()"></p>

                                            <a :href="billing.getBilletUrlView()" 
                                                v-show="billing.hasBillets()"
                                                class="dropdown-item"
                                                target="_blank">Visualizar boleto <fa icon="external-link-alt" class="ml-2 text-muted" /></a>

                                            <a :href="billing.getBilletUrlPdf()"                                                 
                                                v-show="billing.hasBillets()"
                                                class="dropdown-item"
                                                target="_blank">Visualizar PDF do boleto <fa icon="external-link-alt" class="ml-2 text-muted" /></a>

                                            <span class="dropdown-item" 
                                                @click="openResendBillingEmailModal(billing)">Reenviar boleto</span>

                                            <span class="dropdown-item" 
                                                v-show="!billing.hasBilletBeenPaid()"
                                                @click="openApproveBilletPaymentModal(billing)">Aprovar pagamento do boleto</span>

                                            <span class="dropdown-item" 
                                                v-show="billing.hasBillets()"
                                                @click="openBilletHistoryModal(billing)">Visualizar histórico do boleto</span>

                                            <span class="dropdown-item" 
                                                v-show="billing.hasBillets()"
                                                @click="openBilletLogModal(billing)">Visualizar log do boleto</span>

                                            <p class="dropdown-divider" v-show="billing.hasInvoices()"></p>

                                            <a :href="billing.getInvoiceUrl()" 
                                                v-show="billing.hasInvoices()"
                                                class="dropdown-item"
                                                target="_blank">Visualizar NFS-e <fa icon="external-link-alt" class="ml-2 text-muted" /></a>

                                            <p class="dropdown-divider"></p>

                                            <span class="dropdown-item"
                                            v-show="(!billing.hasBillets() && !billing.hasInvoices()) || (billing.getBillet().hasBeenCanceled() && billing.getInvoice().hasBeenCanceled())"
                                                @click="openBillingCancelationModal(billing)">
                                                <span v-show="!billing.hasBeenCanceled()">Cancelar</span>
                                                <span v-show="billing.hasBeenCanceled()">Excluir</span>

                                                faturamento
                                            </span>

                                            <span class="dropdown-item"
                                                v-show="billing.hasBillets() && !billing.getBillet().hasBeenCanceled()"
                                                @click="openBilletCancelationModal(billing)">Cancelar boleto</span>

                                            <span class="dropdown-item"
                                                v-show="billing.hasInvoices() && !billing.getInvoice().hasBeenCanceled()"
                                                @click="openInvoiceCancelationModal(billing)">Cancelar NFS-e</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <ListCount :amount="billingList.length" />
                </div>

                <div v-if="showPaginationButton" class="text-center">
                    <button class="btn btn-outline-secondary"
                        @click="getMoreBillings()"
                        :disabled="loadingNextPage">
                        <span v-show="!loadingNextPage">Mais resultados</span>
                        <fa v-show="loadingNextPage" icon="sync-alt" spin/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { PaginationModel } from '@/utils/models/PaginationModel'
import { BillingListFilterFormModel } from '../models/BillingListFilterFormModel'
import { dateFilter, dateTimeFilter, dateFromStringFilter } from '@/utils/filters/DateTimeFilter'
import billingService from '../services/BillingService'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import ModalService from '@/utils/services/ModalService'
import { cloneDeep, debounce } from 'lodash'
import FilterInformationCmp from '@/utils/components/FilterInformationCmp'
import { BillingModel } from '../models/BillingModel'
import { BillingDocumentCreationModel } from '../models/BillingDocumentCreationModel'
import { BillingCreationModel } from '../models/BillingCreationModel'
import { ApprovedPaymentModel } from '../models/ApprovedPaymentModel'
import { BillingEmailModel } from '../models/BillingEmailModel'
import { BillingUpdateInformationModel } from '../models/BillingUpdateInformationModel'
import subscriberService from '../../subscriber/services/SubscriberService'
import { SubscriberListFilterFormModel } from '../../subscriber/models/SubscriberListFilterFormModel'
import productService from '../../product/services/ProductService'
import { BilletCancelationModel } from '../models/BilletCancelationModel'
import { InvoiceCancelationModel } from '../models/InvoiceCancelationModel'
import { addMonths, subMonths } from 'date-fns'
import { BillingStatusEnum } from '../enums/BillingStatusEnum'
import { SubscriberModel } from '../../subscriber/models/SubscriberModel'

const ID_BILLING_LIST_FILTER_MODAL = '#c2b-billing-list-filter-modal'
const ID_SPECIFIC_BILLING_MODAL = '#c2b-specific-billing-modal'
const ID_BILLING_DOCUMENTS_CREATION_MODAL = '#c2b-billing-documents-creation-modal'
const ID_BILLINGS_CREATION_MODAL = '#c2b-billings-creation-modal'
const ID_APPROVE_BILLET_MODAL = '#c2b-approve-billet-modal'
const ID_UPDATE_BILLING_INFORMATION_MODAL = '#c2b-update-billing-information-modal'
const ID_RESEND_BILLING_EMAIL_MODAL = '#c2b-resend-billing-email-modal'
const ID_BILLING_CANCELATION_MODAL = '#c2b-billing-cancelation-modal'
const ID_BILLET_CANCELATION_MODAL = '#c2b-billet-cancelation-modal'
const ID_BILLET_HISTORY_MODAL = '#c2b-billet-history-modal'
const ID_BILLET_LOG_MODAL = '#c2b-billet-log-modal'
const ID_INVOICE_CANCELATION_MODAL = '#c2b-invoice-cancelation-modal'

export default {
    name: 'BillingListView',
    components: {
        FilterInformationCmp,
    },
    filters: {
        dateFilter,
        dateTimeFilter,
        dateFromStringFilter,
        infoOrPlaceholder,
    },
    data() {
        return {
            loading: true,
            loadingNextPage: false,
            loadingFilter: false,
            showPaginationButton: true,
            openingFilterModal: false,
            openingBillingCreationModal: false,
            approvingBilletPayment: false,
            creatingBillingDocuments: false,
            creatingBillings: false,
            submittingResendEmail: false,
            updatingBillingInformation: false,
            cancelingBilling: false,
            cancelingBillet: false,
            cancelingInvoice: false,
            loadingSubscribers: false,
            billing: new BillingModel(),
            billingList: [],
            billingTypeList: [],
            billingStatusList: [
                {
                    enum: BillingStatusEnum.All,
                    description: "Todos",
                },
                {
                    enum: BillingStatusEnum.Overdue,
                    description: "Vencido",
                },
                {
                    enum: BillingStatusEnum.Open,
                    description: "Em aberto",
                },
                {
                    enum: BillingStatusEnum.Paid,
                    description: "Pago",
                },
                {
                    enum: BillingStatusEnum.Canceled,
                    description: "Cancelado",
                },
            ],
            billetHistoryList: [],
            billetLogList: [],
            availableMonthList: BillingCreationModel.getAvailableMonths(),
            billingDocumentCreation: new BillingDocumentCreationModel(),
            billingCreation: new BillingCreationModel(),
            billingEmail: new BillingEmailModel(),
            billingUpdateInformation: new BillingUpdateInformationModel(),
            billetCancelation: new BilletCancelationModel(),
            invoiceCancelation: new InvoiceCancelationModel(),
            invoiceCancelationCodeOptions: InvoiceCancelationModel.getInvoiceCancelationCodeWrappedList(),
            subscriberList: [],
            productList: [],
            billingFilterForm: new BillingListFilterFormModel(),
            billingFilterSubmitted: new BillingListFilterFormModel(),
            pagination: new PaginationModel(),
            approvedPayment: new ApprovedPaymentModel(),
            billingFilterProperties: [
                {
                    type: 'object',
                    label: 'Cliente',
                    property: 'subscriber',
                    propertyInObject: 'name',
                },
                {
                    type: 'daterange',
                    label: 'Data',
                    property: 'date',
                },
                {
                    type: 'list',
                    label: 'Tipo',
                    property: 'typeList',
                    propertyInList: 'name',
                },
                {
                    type: 'object',
                    label: 'Status do faturamento',
                    property: 'status',
                    propertyInObject: 'description',
                },
            ],
        }
    },
    created() {
        // The creation of a debounced method inf the `created` lifecycle is intentional
        this.getSubscribers = debounce(async (subscriberName) => {
            this.loadingSubscribers = true

            try {
                const subscriberFilter = new SubscriberListFilterFormModel({name: subscriberName})
                const subscriberList = await subscriberService.getSubscriberList(this.pagination.reset(), subscriberFilter)

                this.subscriberList = subscriberList.map((subscriber) => {
                    return new SubscriberModel({
                        ...subscriber,
                        name: `${subscriber.name} (${subscriber.document})`
                    })
                })
            } catch (err) {
                throw err
            }

            this.loadingSubscribers = false
        }, 500)
    },
    async mounted() {
        this.loading = true

        try {
            if (this.$route.query.idSubscriber) {
                const subscriber = await subscriberService.getSubscriberById(this.$route.query.idSubscriber)
                this.billingFilterForm = new BillingListFilterFormModel({
                    subscriber,
                    date: {
                        start: subMonths(new Date(), 6),
                        end: addMonths(new Date(), 6),
                    },
                })
                this.billingFilterSubmitted = cloneDeep(this.billingFilterForm)
            }

            this.billingList = await billingService.getBillingList(this.pagination.actual(), this.billingFilterForm)            

            if (!this.billingList.length) {
                this.showPaginationButton = false
            } else {
                this.pagination.next()
            }
        } catch(err) {
            this.showPaginationButton = false
            
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async getMoreBillings() {
            this.loadingNextPage = true

            try {
                const billingList = await billingService.getBillingList(this.pagination.actual(), this.billingFilterForm)

                if (billingList.length) {
                    this.billingList.push(...billingList)
                    this.pagination.next()
                } else {
                    this.showPaginationButton = false
                }
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }            

            this.loadingNextPage = false
        },
        async getBillingListWithFilter(billingFilter) {
            this.loadingFilter = true

            this.billingFilterSubmitted = cloneDeep(billingFilter)
            
            try {
                this.pagination.reset()
                this.billingList = await billingService.getBillingList(this.pagination.actual(), this.billingFilterSubmitted)

                if (!!this.billingList.length) {
                    this.showPaginationButton = true
                    this.pagination.next()
                } else {
                    this.showPaginationButton = false
                }
                this.closeFilterModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.loadingFilter = false
        },
        clearFilter() {
            this.billingFilterForm = new BillingListFilterFormModel()
        },
        async openFilterModal() {
            this.openingFilterModal = true

            try {
                if (!this.billingTypeList.length) {
                    this.billingTypeList = await billingService.getBillingTypeList()
                }

                ModalService.show(ID_BILLING_LIST_FILTER_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.openingFilterModal = false
        },
        closeFilterModal() {
            ModalService.hide(ID_BILLING_LIST_FILTER_MODAL)
        },
        async openSpecificBillingModal(billing) {
            billing.loadingListAction = true

            try {
                this.billing = await billingService.getBillingById(billing.id)
                this.approvedPayment = new ApprovedPaymentModel()
                ModalService.show(ID_SPECIFIC_BILLING_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            billing.loadingListAction = false
        },
        closeSpecificBillingModal() {
            ModalService.hide(ID_SPECIFIC_BILLING_MODAL)
        },
        async openApproveBilletPaymentModal(billing) {
            billing.loadingListAction = true

            try {
                this.billing = await billingService.getBillingById(billing.id)
                this.approvedPayment = new ApprovedPaymentModel()
                ModalService.show(ID_APPROVE_BILLET_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            billing.loadingListAction = false
        },
        closeApproveBilletModal() {
            ModalService.hide(ID_APPROVE_BILLET_MODAL)
        },
        async updateBillingInformation(billing, billingUpdateInformation) {
            this.updatingBillingInformation = true

            try {
                await billingService.updateInformation(billing.id, billingUpdateInformation.getInformationFormatted())
                await this._updateBillingInList(billing)
                this.closeUpdateBillingInformationModal()
                this.$floatingAlert.success({
                    message: `Informações atualizadas com sucesso.`,
                })
            } catch(err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.updatingBillingInformation = false
        },
        async openUpdateBillingInformationModal(billing) {
            billing.loadingListAction = true

            try {
                this.billing = await billingService.getBillingById(billing.id)
                this.billingUpdateInformation = new BillingUpdateInformationModel({email: billing.getEmail()})
                ModalService.show(ID_UPDATE_BILLING_INFORMATION_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            billing.loadingListAction = false
        },
        closeUpdateBillingInformationModal() {
            ModalService.hide(ID_UPDATE_BILLING_INFORMATION_MODAL)
        },
        async resendBillingEmail(billing, billingEmail) {
            this.submittingResendEmail = true

            try {
               await billingService.resendBillingEmail(billing.id, billingEmail)
               this.$floatingAlert.success({
                   message: `Boleto do cliente ${billing.subscriberProduct.subscriber.name} com vencimento em ${billing.dueDate} reenviado para ${billingEmail.email}.`
               })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.submittingResendEmail = false
        },
        async openResendBillingEmailModal(billing) {
            billing.loadingListAction = true

            try {
                this.billing = await billingService.getBillingById(billing.id)
                this.billingEmail = new BillingEmailModel({email: this.billing.getEmail()})
                ModalService.show(ID_RESEND_BILLING_EMAIL_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            billing.loadingListAction = false
        },
        closeResendBillingEmailModal() {
            ModalService.hide(ID_RESEND_BILLING_EMAIL_MODAL)
        },
        async approveBilletPayment(billing, approvedPayment) {
            this.approvingBilletPayment = true

            try {
                await billingService.approvePayment(billing.id, approvedPayment)
                await this._updateBillingInList(billing)
                this.closeApproveBilletModal()
                this.$floatingAlert.success({
                    message: `Boleto aprovado com sucesso.`,
                })
            } catch(err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }
            
            this.approvingBilletPayment = false
        },
        async createBillings(billingCreation) {
            this.creatingBillings = true

            try {
                await billingService.createBillings(billingCreation.getInformationFormatted())
                this.closeBillingCreationModal()
                this.$floatingAlert.success({
                    message: `Faturamentos criados com sucesso.`,
                })
            } catch(err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.creatingBillings = false
        },
        async openBillingCreationModal() {
            this.openingBillingCreationModal = true

            this.billingCreation = new BillingCreationModel()
            try {
                this.productList = await productService.getProductList()
                this.billingCreation.product = cloneDeep(this.productList[0])
                ModalService.show(ID_BILLINGS_CREATION_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.openingBillingCreationModal = false
        },
        closeBillingCreationModal() {
            ModalService.hide(ID_BILLINGS_CREATION_MODAL)
        },
        async createBillingDocuments(billingDocumentCreation) {
            this.creatingBillingDocuments = true

            try {
                await billingService.createBillingDocuments(billingDocumentCreation.getInfoFormatted())
                this.closeBillingDocumentsCreationModal()
                this.$floatingAlert.success({
                    message: `Boletos gerados com sucesso.`,
                })
            } catch(err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.creatingBillingDocuments = false
        },
        openBillingDocumentsCreationModal() {
            this.billingDates = new BillingDocumentCreationModel()
            ModalService.show(ID_BILLING_DOCUMENTS_CREATION_MODAL)
        },
        closeBillingDocumentsCreationModal() {
            ModalService.hide(ID_BILLING_DOCUMENTS_CREATION_MODAL)
        },
        async cancelOrDeleteBilling(billing) {
            this.cancelingBilling = true

            try {
               const result = await billingService.cancelOrDeleteBilling(billing.id)
               this.closeBillingCancelationModal()

               if (!!result) {
                    await this._updateBillingInList(result);
                    this.$floatingAlert.success({
                        message: `Faturamento do cliente ${billing.subscriberProduct.subscriber.name} com vencimento em ${billing.dueDate} cancelado.`
                    })                  
               } else {
                    this._removeBillingFromList(billing);
                    this.$floatingAlert.success({
                        message: `Faturamento do cliente ${billing.subscriberProduct.subscriber.name} com vencimento em ${billing.dueDate} excluído.`
                    })
               }
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.cancelingBilling = false
        },
        async openBillingCancelationModal(billing) {
            billing.loadingListAction = true

            try {
                this.billing = await billingService.getBillingById(billing.id)
                ModalService.show(ID_BILLING_CANCELATION_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            billing.loadingListAction = false
        },
        closeBillingCancelationModal() {
            ModalService.hide(ID_BILLING_CANCELATION_MODAL)
        },
        async cancelBillet(billing, billetCancelation) {
            this.cancelingBillet = true

            try {
               const result = await billingService.cancelBillet(billing.id, billetCancelation)
               await this._updateBillingInList(result)
               this.closeBilletCancelationModal()
               this.$floatingAlert.success({
                   message: `Boleto do cliente ${billing.subscriberProduct.subscriber.name} com vencimento em ${billing.dueDate} cancelado.`
               })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.cancelingBillet = false
        },
        async openBilletCancelationModal(billing) {
            billing.loadingListAction = true

            try {
                this.billing = await billingService.getBillingById(billing.id)
                ModalService.show(ID_BILLET_CANCELATION_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            billing.loadingListAction = false
        },
        closeBilletCancelationModal() {
            ModalService.hide(ID_BILLET_CANCELATION_MODAL)
        },
        async cancelInvoice(billing, invoiceCancelation) {
            this.cancelingInvoice = true

            try {
               const result = await billingService.cancelInvoice(billing.id, invoiceCancelation.getInformationNormalized())
               await this._updateBillingInList(result)
               this.closeInvoiceCancelationModal()
               this.$floatingAlert.success({
                   message: `Nota de serviço do cliente ${billing.subscriberProduct.subscriber.name} com vencimento em ${billing.dueDate} cancelada.`
               })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.cancelingInvoice = false
        },
        async openInvoiceCancelationModal(billing) {
            billing.loadingListAction = true

            try {
                this.billing = await billingService.getBillingById(billing.id)
                ModalService.show(ID_INVOICE_CANCELATION_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            billing.loadingListAction = false
        },
        closeInvoiceCancelationModal() {
            ModalService.hide(ID_INVOICE_CANCELATION_MODAL)
        },
        async openBilletHistoryModal(billing) {
            billing.loadingListAction = true

            try {
                this.billing = await billingService.getBillingById(billing.id)
                this.billetHistoryList = await billingService.getBilletHistory(billing.getBillet().id)
                ModalService.show(ID_BILLET_HISTORY_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            billing.loadingListAction = false
        },
        closeBilletHistoryModal() {
            ModalService.hide(ID_BILLET_HISTORY_MODAL)
        },
        async openBilletLogModal(billing) {
            billing.loadingListAction = true

            try {
                this.billing = await billingService.getBillingById(billing.id)
                this.billetLogList = cloneDeep(this.billing.getBillet().logs)
                ModalService.show(ID_BILLET_LOG_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            billing.loadingListAction = false
        },
        closeBilletLogModal() {
            ModalService.hide(ID_BILLET_LOG_MODAL)
        },
        async _updateBillingInList(billing) {
            for (let i = 0; i < this.billingList.length; i++) {
                if (this.billingList[i].id === billing.id) {
                    this.billingList[i] = await billingService.getBillingById(billing.id)
                    break
                }
            }
        },
        async _removeBillingFromList(billing) {
            for (let i = 0; i < this.billingList.length; i++) {
                if (this.billingList[i].id === billing.id) {
                    this.billingList.splice(i, 1)
                    break
                }
            }
        },
    },
    computed: {
        nothingToShow() {
            return !this.loading && !this.billingList.length
        },
        billingListCsv() {
            return this.billingList.map((billing) => {
                let billetStatus = ''
                let invoiceStatus = ''

                if (billing.hasBillets() && billing.getBillet().hasBeenCanceled()) {
                    billetStatus = 'Não gerado'
                }

                if (billing.hasBillets() && !billing.getBillet().hasBeenCanceled()) {
                    billetStatus = 'Gerado'
                }

                if (billing.hasBillets() && billing.getBillet().hasBeenCanceled()) {
                    billetStatus = 'Cancelado'
                }

                if (billing.hasInvoices() && billing.getInvoice().hasBeenCanceled()) {
                    invoiceStatus = 'Não gerado'
                }

                if (billing.hasInvoices() && !billing.getInvoice().hasBeenCanceled()) {
                    invoiceStatus = 'Gerado'
                }

                if (billing.hasInvoices() && billing.getInvoice().hasBeenCanceled()) {
                    invoiceStatus = 'Cancelado'
                }

                return {
                    cliente_razao_social: billing.subscriberProduct.subscriber.realName,
                    cliente_nome_fantasia: billing.subscriberProduct.subscriber.name,
                    cliente_alias: billing.subscriberProduct.subscriber.alias,
                    cnpj: billing.subscriberProduct.subscriber.document,
                    codigo_crm: billing.subscriberProduct.subscriber.idExternal,
                    tipo_cobrança: billing.type.name,
                    vencimento_cobranca: dateFromStringFilter(billing.dueDate),
                    status_cobranca: billing.getStatusDescription(),
                    status_boleto: billetStatus,
                    status_nfse: invoiceStatus,
                    valor_total: billing.total,
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.modal {
    .modal-body {
        .billet-history-container {
            max-height: 350px;
            overflow: hidden;
            overflow-y: auto;
            width: 100%;

            .billet-history {
                padding: 8px 16px;
                border-top: 1px dashed #ddd;
                background-color: #f9f9fa;

                &:last-of-type {
                    border-bottom: 1px dashed #ddd;
                }
            }
        }
    }
}
</style>